import { render, staticRenderFns } from "./MyTicketsList.vue?vue&type=template&id=72d99516&scoped=true&"
import script from "./MyTicketsList.vue?vue&type=script&lang=js&"
export * from "./MyTicketsList.vue?vue&type=script&lang=js&"
import style0 from "./MyTicketsList.vue?vue&type=style&index=0&id=72d99516&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72d99516",
  null
  
)

export default component.exports